import cn from 'classnames';
import { useExperiment } from '@/hooks/experiments';
import styles from '../CreateRentalRequestPage.module.css';

export const RequestPageHeader = () => {
    const experiment = useExperiment();
    const showUpdatedRequestPage = experiment?.['travel-fhh-tjvr-request-page-drop-off-reduction'] === 'treatment';

    return (
        <header className={cn(styles.header, 'mb-32 md:mb-0')}>
            <h1 className="h3 md:h2">{showUpdatedRequestPage ? 'Send en uforpliktende forespørsel' : 'Nå er du snart i mål'}</h1>
            <p className="md:max-w-[450px]">
                {showUpdatedRequestPage
                    ? 'Vi trenger bare litt mer informasjon før du sender forespørselen.'
                    : 'Vi behøver bare litt mer informasjon før forespørselen kan sendes. Denne informasjonen deles også med utleier av feriehjemmet.'}
            </p>
        </header>
    );
};
